export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'drisk-access-token';
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'drisk-refresh-token';

export function setToken(accessToken: string, refreshToken: string) {
  localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY, refreshToken);
}

export function clearToken() {
  localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY);
  localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY);
}
